/**
 * Wandelt vom {@link PmRichTextEditor} erzeugtes HTML in reinen Text um —
 * für Kontexte ohne HTML-Rendering (Tabellen-Vorschau, PDF-/Word-Export).
 * Bewusst leichtgewichtig (keine DOM-/Editor-Abhängigkeit), damit Report-
 * Module nicht die Editor-/Tiptap-Bundles mitziehen.
 */
export function richTextToPlainText(html: string | null | undefined): string {
  if (!html) return '';
  const withBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|h[1-6]|li|blockquote)>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ');
  const stripped = withBreaks
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");
  return stripped
    .split('\n')
    .map((line) => line.trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
